import axios from "axios";
import authService from "../modules/authService";
import Vue from "vue";
import router from "@/router/index";
import i18n from "@/plugins/i18n";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
// import store from "../../store";

const headers = {
  "content-type": "application/json",
  Accept: "application/json",
  "Accept-Language": "fa",
  version: "1000",
  "client-lang": VueCookies.get("lang") || null
};

const API_V3 = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_V3,
  headers: headers
});

const API_V4 = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_V4,
  headers: headers
});

const API_DEV = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_DEV,
  headers: headers
});

API_DEV.interceptors.request.use(
  config => {
    const token = authService.getAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    config.headers["Client-Lang"] = Vue.$cookies.get("lang");
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

API_V4.interceptors.request.use(
  config => {
    config.headers["Accept-Language"] = i18n.locale;
    const uuid = Vue.$cookies.get("CA_ID");
    config.headers["Client-Lang"] = i18n.locale;
    const token = Vue.$cookies.get("accessToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    if (uuid) {
      config.headers["account-id"] = uuid;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

API_V3.interceptors.request.use(
  config => {
    const token = Vue.$cookies.get("accessToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// متغیرها برای صف ریکویست‌ها هنگام رفرش توکن
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

API_V4.interceptors.response.use(
  response => {
    return response;
  },
  async function(error) {
    const originalRequest = error.config;

    // هندل رفرش توکن در صورت 401
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axios(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      isRefreshing = true;

      try {
        const refreshToken = Vue.$cookies.get("refreshToken");

        const res = await axios.post(
          `${process.env.VUE_APP_BASE_URL_V4}/users/token/get-by-refresh`,
          { refresh_token: refreshToken }
        );
        localStorage.setItem("accessToken", res.data.data.token);
        Vue.$cookies.set("accessToken", res.data.data.token);

        localStorage.setItem("refreshToken", res.data.data.refresh_token);
        Vue.$cookies.set("refreshToken", res.data.data.refresh_token);

        processQueue(null, res.data.data.token);
        originalRequest.headers["Authorization"] =
          "Bearer " + res.data.data.token;

        return axios(originalRequest);
      } catch (err) {
        processQueue(err, null);
        await localStorage.setItem("isAuth", "false");
        await localStorage.removeItem("accessToken");
        await Vue.$cookies.remove("CA_ID");
        await Vue.$cookies.remove("isLegal");
        this.$cookies.set("showAlert", "false");
        await Vue.$cookies.remove("accessToken");
        await Vue.$cookies.remove("accessToken", null, ".ernyka.com");
        await Vue.$cookies.remove("accessToken", null, ".excoino.com");
        window.location = `${process.env.VUE_APP_BASE_URL}/auth/login`;

        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    // هندل ارور ۵۰۰
    if (error.response.status >= 500) {
      router.push({
        name: "error-page",
        params: { errorBody: error.response }
      });
    }

    // هندل ارور ۴۰۳
    if (
      error.response.status === 403 &&
      (error.response.data.code === "auth_token_invalid" ||
        error.response.data.code === "user_blocked")
    ) {
      await localStorage.setItem("isAuth", "false");
      await localStorage.removeItem("accessToken");
      await Vue.$cookies.remove("accessToken");
      await Vue.$cookies.remove("accessToken", null, ".ernyka.com");
      await Vue.$cookies.remove("accessToken", null, ".excoino.com");
      window.location = `${process.env.VUE_APP_BASE_URL}/auth/login`;
    }

    // toast خطاها برای ریکوئست‌های غیر GET
    if (error && error.response.config.method !== "get") {
      Vue.$toast.clear();

      Vue.$toast.updateDefaults({
        rtl: localStorage.getItem("direction") === "rtl" ? true : false
      });

      if (error.response.data.errors) {
        if (Object.entries(error.response.data.errors).length > 0) {
          Object.values(error.response.data.errors).forEach(value => {
            Vue.$toast.error(value[0]);
          });
        } else {
          Vue.$toast.error(error.response.data.message);
        }
      } else {
        Vue.$toast.error(error.response.data.message);
      }
    }

    return Promise.reject(error.response);
  }
);

export { API_V3, API_V4, API_DEV };
